import React from "react";
import "./LoadingIcon.css";

const LoadingIcon = () => {
  return (
    <div className="loading-container">
      <div className="circle-wrapper">
        <div className="circle-spinner"></div>
        <img
          src="/logo.png"   // direct image path from public folder
          alt="Company Logo"
          className="logo"
          loading="lazy"
        />
      </div>
    
    </div>
  );
};

export default LoadingIcon;
